// contexts/MobileMenuContext.js
'use client'

import { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { usePathname } from 'next/navigation'

const MobileMenuContext = createContext(null)

export function MobileMenuProvider({ children }) {
    const [isMobileOpen, setIsMobileOpen] = useState(false)
    const pathname = usePathname()

    // Auto-close sidebar whenever the route changes.
    // This handles back-button navigation and programmatic router.push calls
    // that don't go through the sidebar's handleNavClick.
    useEffect(() => {
        setIsMobileOpen(false)
    }, [pathname])

    const toggleMobileMenu = useCallback(() => {
        setIsMobileOpen(prev => !prev)
    }, [])

    const closeMobileMenu = useCallback(() => {
        setIsMobileOpen(false)
    }, [])

    const openMobileMenu = useCallback(() => {
        setIsMobileOpen(true)
    }, [])

    return (
        <MobileMenuContext.Provider value={{
            isMobileOpen,
            setIsMobileOpen,
            toggleMobileMenu,
            closeMobileMenu,
            openMobileMenu
        }}>
            {children}
        </MobileMenuContext.Provider>
    )
}

export function useMobileMenu() {
    const context = useContext(MobileMenuContext)
    if (!context) {
        throw new Error('useMobileMenu must be used within a MobileMenuProvider')
    }
    return context
}